import { KanbanBoard, UnifiedKanbanCard } from "@/components/ui";

export const CustomersKanban = ({ 
  stages = [], 
  filtered = [], 
  onCustomerClick, 
  onStatusChange,
  onUpdate,
  onEdit,
  onToggleDisable,
  teamMembers = []
}) => {
  return (
    <KanbanBoard
      className="bg-slate-50/30 p-4"
      stages={stages}
      items={filtered.map(item => ({
        ...item,
        isLocked: item.isDisabled || ["project_started", "project_start"].includes(item.status) || (
          item.teleStatus !== "converted" && item.status !== "converted" && 
          item.isConvertedByTelecaller && !["new", "assigned", "converted", "site_visit"].includes(item.status)
        )
      }))}
      onItemMove={(item, stageKey) => onStatusChange && onStatusChange(item, stageKey)}
      renderCard={(item) => (
        <UnifiedKanbanCard
          item={item}
          onClick={onCustomerClick}
          onUpdate={onUpdate}
          onEdit={onEdit}
          onToggleDisable={onToggleDisable}
          teamMembers={teamMembers}
          variant="contact"
        />
      )}
    />
  );
};
